import { BloxHistory } from './bloxHistory'
import { StudentBloxSelection } from './bloxSelection'
import { DiscussionGroups } from './discussionGroups'
import { FormationRules } from './formationRules'
import { StudentHome } from './home'
import { LmsHome } from './lms'
import { ScheduleSelection } from './scheduleSelection'

export default {
  StudentHome,
  StudentBloxSelection,
  LmsHome,
  BloxHistory,
  DiscussionGroups,
  FormationRules,
  ScheduleSelection,
}
